import React from 'react';
import { dlsCardBlue, Heading, Logo } from '@americanexpress/dls-react';
import { getHeading } from '../../helper/functions';

const Header = () => (
  <div className="header">
    <nav
      className="nav nav-horizontal border nav-header nav-large"
      data-toggle="nav"
      data-responsive="true"
      data-overlay="true"
    >
      <div className="nav-brand">
        <Logo
          className="margin-responsive-r"
          styleType="bluebox-solid"
          size="lg"
          alt="blue box large"
        />
        <div className="flex flex-align-items-center">
          <Heading
            className="cursor-pointer"
            headingStyle="heading5g"
            theme={dlsCardBlue}
          >
            <p className='header-text'>
            {getHeading()}
            </p>
          </Heading>
        </div>
      </div>
    </nav>
  </div>
);

export default Header;
